<template>
  <main class="homepage">
    <HeroSection />
    <VideoSection />
    <BenefitsSection />
    <LogoSection :logos="logos" />
    <DeveloperTypeSection />
    <NewsSection
      v-if="articles"
      :articles="articles"
      section-title="What's new at<br />Proxify?"
    />
    <SubscribeSection />
    <OurReachSection />
  </main>
</template>

<script>
import HeroSection from './HeroSection/HeroSection.vue';
import VideoSection from './VideoSection/VideoSection.vue';
import BenefitsSection from './BenefitsSection/BenefitsSection.vue';
import LogoSection from './LogoSection/LogoSection.vue';
import DeveloperTypeSection from './DeveloperTypeSection/DeveloperTypeSection.vue';
import OurReachSection from '~/components/Common/OurReachSection/OurReachSection.vue';
import NewsSection from '~/components/Common/NewsSection/NewsSection.vue';
import SubscribeSection from '~/components/Common/SubscribeSection/SubscribeSection.vue';

export default {
  components: {
    HeroSection,
    BenefitsSection,
    LogoSection,
    DeveloperTypeSection,
    NewsSection,
    SubscribeSection,
    OurReachSection,
    VideoSection,
  },
  props: {
    articles: {
      type: Array,
      required: true,
    },
    logos: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './HomePage.scss';
</style>
